<!-- Body -->
<div class="row" style="overflow: hidden; height: 10%;">
    <div class="col h-100 w-100 pb-2">
        <app-notice-scroll></app-notice-scroll>
    </div>
</div>
<div class="content-background pb-2 pt-2">
    <div *ngIf="loading" class="page-wrap align-items-center mt-5">
        <div class="container">
            <div class="row justify-content-right">
                <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!loading">
        <div class="col">
            <div class="float-right pr-2">
                <app-advanced-mode [storageKey]="'dashboard'" (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
            </div>
            <div class="float-right pr-4">
                <label class="control-label text-uppercase montserrat">
                    {{'COLLAPSED' | translate}}
                </label>&nbsp;
                <kendo-switch [(ngModel)]="collapseAll" (valueChange)="updateProgramCollapse(groupFilter, $event)"
                    attr.aria-label="{{'COLLAPSED' | translate}}">
                </kendo-switch>
            </div>
        </div>
    </div>
    <div style="padding-left: 15px; padding-right: 15px;"
        *ngxPermissionsOnly="['ROLE_PROGRAM_LEAD', 'ROLE_PROGRAM_SUPPORT', 'ROLE_CARE_COORDINATOR', 'ROLE_OPERATOR']">
        <div class="row">
            <!--Grouping panel-->
            <div *ngIf="enableAdvanced" class="col-md-12 card card-shadow card-filter-container mt-3 pb-1">
                <form [formGroup]="filterForm" class="k-form">
                    <div class="mt-2 row">
                        <!--Group By-->
                        <label class="col-xl-3 col-lg-4 col-xs-12">
                            <span for="groupBy" class="w-100">
                                <i class="fal fa-fw fa-folders"></i>
                                <span class="k-text-uppercase dark" [ngClass]="{'active-filter-text': isGrouped}">
                                    {{'PROGRAM-GROUP-BY' | translate}}
                                </span>
                                <kendo-combobox class="w-100" [data]="listGroupBy" [textField]="'text'"
                                    formControlName="groupBy" [valueField]="'value'" [valuePrimitive]="true"
                                    attr.aria-label="{{'PROGRAM-GROUP-BY' | translate}}">
                                </kendo-combobox>
                            </span>
                        </label>
                        <!--Filter Category-->
                        <label class="col-xl-3 col-lg-8 col-xs-12">
                            <span for="filterByCategory" class="w-100">
                                <span class="k-text-uppercase dark"
                                    [ngClass]="{'active-filter-text': isFiltered('filterByCategory')}">
                                    <i class="fal fa-fw fa-filter"></i>
                                    {{'PROGRAM-FILTER-CATEGORY' | translate}}
                                </span>
                                <kendo-multiselect [data]="programCategories" formControlName="filterByCategory"
                                    attr.aria-label="{{'PROGRAM-FILTER-CATEGORY' | translate}}" [textField]="'name'"
                                    [valueField]="'id'" [autoClose]="true" [valuePrimitive]="true">
                                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                        <div class="m-1">
                                            <input type="checkbox" attr.aria-label="{{ dataItem.name }}"
                                                [checked]="isFilterSelected('filterByCategory',dataItem.id)"
                                                kendoCheckBox
                                                [attr.aria-checked]="isFilterSelected('filterByCategory', dataItem.id) ? 'true' : 'false'" />
                                            <label class="k-checkbox-label">{{ dataItem.name }}</label>
                                        </div>
                                    </ng-template>
                                </kendo-multiselect>
                            </span>
                        </label>
                        <!--Filter Status-->
                        <label class="col-xl-3 col-lg-4 col-xs-12">
                            <span for="filterByStatus" class="w-100">
                                <span class="k-text-uppercase dark"
                                    [ngClass]="{'active-filter-text': isFiltered('filterByStatus')}">
                                    <i class="fal fa-fw fa-filter"></i>
                                    {{'PROGRAM-FILTER-STATUS' | translate}}
                                </span>
                                <kendo-multiselect [data]="channelStatuses" formControlName="filterByStatus"
                                    [textField]="'text'" [valueField]="'value'" [autoClose]="true"
                                    [valuePrimitive]="true" attr.aria-label="{{'PROGRAM-FILTER-STATUS' | translate}}">
                                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                        <div class="m-1">
                                            <input type="checkbox"
                                                [checked]="isFilterSelected('filterByStatus',dataItem.value)"
                                                kendoCheckBox role="checkbox" />
                                            <label class="k-checkbox-label">{{ dataItem.text }}</label>
                                        </div>
                                    </ng-template>
                                </kendo-multiselect>
                            </span>
                        </label>
                    </div>
                    <!--Sort by-->
                    <div class="mt-2 row">
                        <label class="col-xl-3 col-lg-4 col-xs-12">
                            <span for="sortBy" class="w-100">
                                <i class="fal fa-fw fa-sort"></i>
                                <span class="k-text-uppercase dark" [ngClass]="{'active-filter-text': isSorted}">
                                    {{'PROGRAM-SORT-BY' | translate}}
                                </span>
                                <kendo-combobox class="w-100" [data]="channelSorts" [textField]="'text'"
                                    formControlName="sortBy" [valueField]="'value'" [valuePrimitive]="true"
                                    attr.aria-label="{{'PROGRAM-SORT-BY' | translate}}">
                                </kendo-combobox>
                            </span>
                        </label>
                        <!--Sort direction-->
                        <div class="col-xl-3 col-lg-4 col-xs-12">
                            <span for="sortDirection" *ngIf="isSorted">
                                <i *ngIf="sortDirection.value === 'asc'" class="far fa-sort-amount-up"></i>
                                <i *ngIf="sortDirection.value === 'desc'" class="far fa-sort-amount-down"></i>
                                <span class="k-text-uppercase dark" [ngClass]="{'active-filter-text': isSorted}">
                                    {{'SORT-DIRECTION' | translate}}
                                </span>
                                <br />
                                <div class="mt-2">
                                    <input type="radio" value="asc" name="sortDirection" formControlName="sortDirection"
                                        id="radioAscending" kendoRadioButton />
                                    <label class="k-radio-label" for="radioAscending">{{'SORT-ASCENDING' |
                                        translate}}</label>
                                    <input type="radio" value="desc" name="sortDirection"
                                        formControlName="sortDirection" id="radioDescending" kendoRadioButton />
                                    <label class="k-radio-label" for="radioDescending">{{'SORT-DESCENDING' |
                                        translate}}</label>
                                </div>
                            </span>
                        </div>
                        <!--Filter Program Name-->
                        <div class="col-xl-3 col-lg-4 col-xs-12">
                            <span for="filterByProgramName" class="w-100">
                                <span class="k-text-uppercase dark"
                                    [ngClass]="{'active-filter-text': isFiltered('filterByProgramName')}">
                                    <i class="fal fa-fw fa-filter"></i>
                                    {{'PROGRAM-FILTER-PROGRAM-NAME' | translate}}
                                </span>
                                <input kendoTextBox formControlName="filterByProgramName"
                                    attr.aria-label="{{'PROGRAM-FILTER-PROGRAM-NAME' | translate}}" class="w-100" />
                            </span>
                        </div>
                        <!--Filter Channel Name-->
                        <div class="col-xl-3 col-lg-4 col-xs-12">
                            <span for="filterByChannelName" class="w-100">
                                <span class="k-text-uppercase dark"
                                    [ngClass]="{'active-filter-text': isFiltered('filterByChannelName')}">
                                    <i class="fal fa-fw fa-filter"></i>
                                    {{'PROGRAM-FILTER-CHANNEL-NAME' | translate}}
                                </span>
                                <input kendoTextBox formControlName="filterByChannelName"
                                    attr.aria-label="{{'PROGRAM-FILTER-CHANNEL-NAME' | translate}}" class="w-100" />
                            </span>
                        </div>
                    </div>
                    <div class="mt-2 row">
                        <div class="col-xl-3 col-lg-4 col-xs-12"></div>
                        <div class="col-xl-3 col-lg-4 col-xs-12"></div>
                        <div class="col-xl-3 col-lg-4 col-xs-12"></div>
                        <!--Clear and Save filter-->
                        <div class="col-xl-3 col-lg-4 col-xs-12 pt-1 pb-2 text-right" *ngIf="showFilterBtnActions"
                            style="margin:auto;">
                            <i class="far fa-fw fa-times-circle fa-delete-custom mr-3" role="button"
                                attr.aria-label="{{'CLEAR-ALL-FILTER' | translate}}"
                                title="{{'CLEAR-ALL-FILTER' | translate}}" (click)="clearFilters()"
                                style="font-size:20pt" tabindex="0" (keydown.enter)="clearFilters()"
                                (keydown.space)="clearFilters()">
                            </i>
                            <button kendoButton style="margin-top:-10px;" (click)="openFilterScreen()">{{ 'SAVE-FILTER'
                                | translate }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<!--Save filter-->
<app-save-filter [dialogOpened]="filterDialogOpened" [filterCategory]="'Dashboard'" [filterState]="filterForm.value"
    (cancelling)="filterDialogOpened=false;" [filter]="filterSelected">
</app-save-filter>
<div class="content-background pt-0">
    <div class="row" style="overflow: auto;">
        <div *ngIf="isConfigurableDashboardVisible('CASELOAD')" class="col-xl-4 col-md-4 col-xs-12 mh-100 pl-2">
            <app-dashboard-coordinator-top-left [filter]="filterToApply" [performanceComponent]="performanceComponent">
            </app-dashboard-coordinator-top-left>
        </div>
        <div *ngIf="isConfigurableDashboardVisible('EVENTS')" class="col-xl-4 col-md-4 col-xs-12 mh-100">
            <app-dashboard-coordinator-top-center></app-dashboard-coordinator-top-center>
        </div>
        <div *ngIf="isConfigurableDashboardVisible('EVENT_STREAM')" class="col-xl-4 col-md-4 col-xs-12 mh-100 pr-2">
            <app-dashboard-coordinator-top-right></app-dashboard-coordinator-top-right>
        </div>
    </div>
    <div class="row" style="overflow-y: auto; overflow-x: hidden;">
        <div class="col-12 h-100 pb-2 pt-2">
            <app-dashboard-coordinator-middle #performanceComponent [filter]="filterToApply" [groupBy]="groupFilter"
                [sortBy]="sortedBy" [sortDirection]="sortedDirection">
            </app-dashboard-coordinator-middle>
        </div>
    </div>
</div>